import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import imageCompression from 'browser-image-compression';

import { config } from '../../../../../config/index';

import { GET, PUT, newFetch } from '../../../../../helpers/fetch';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';
import placeholderImage from '../../../../../assets/images/placeholder.jpg';

const { SERVER_URL } = config;

const Account = ({ history }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const type = localStorage.getItem('type');

  const [fetchedUser, setFetchedUser] = useState(null);

  const [firstName, setFirstName] = useState(
    type === 'client' ? user.manager_first_name : user.first_name
  );
  const [lastName, setLastName] = useState(
    type === 'client' ? user.manager_last_name : user.last_name
  );
  const [email, setEmail] = useState(user.email);
  const [phoneNo, setPhoneNo] = useState(user.phone_no);
  const [photo, setPhoto] = useState(
    user.image ? `${SERVER_URL}/${user.image}` : placeholderImage
  );
  const [file, setFile] = useState(null);

  const photoHandler = async (e) => {
    var file = e.target.files[0];

    var options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1080,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const compressed = new File([compressedFile], file.name);

      setFile(compressed);
      let reader = new FileReader();
      reader.readAsDataURL(compressed);

      reader.onload = () => {
        setPhoto(reader.result);
      };

      reader.onerror = function (error) {
        ToastUtil.error(error);
      };
    } catch (err) {
      console.log(err);
    }
  };

  const discardAccountHandler = () => {
    if (type === 'superadmin' || type === 'admin') {
      setFirstName(fetchedUser.first_name);
      setLastName(fetchedUser.last_name);
      setEmail(fetchedUser.email);
      setPhoneNo(fetchedUser.phone_no);
      setPhoto(
        fetchedUser.image
          ? `${SERVER_URL}/${fetchedUser.image}`
          : placeholderImage
      );
    }

    if (type === 'client') {
      setFirstName(fetchedUser.manager_first_name);
      setLastName(fetchedUser.manager_last_name);
      setEmail(fetchedUser.email);
      setPhoneNo(fetchedUser.phone_no);
      setPhoto(
        fetchedUser.image
          ? `${SERVER_URL}/${fetchedUser.image}`
          : placeholderImage
      );
    }
  };

  const submitAccountHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update your account details?'
      )
    ) {
      var api_path = '';
      var data = null;

      if (type === 'superadmin' || type === 'admin') {
        api_path = '/admin/profile/update';
        data = {
          first_name: firstName,
          last_name: lastName,
          email: email,
          phone_no: phoneNo,
        };
      }

      if (type === 'client') {
        api_path = '/client/profile/update';
        data = {
          manager_first_name: firstName,
          manager_last_name: lastName,
          email: email,
          phone_no: phoneNo,
        };
      }

      if (api_path) {
        if (file) {
          let formData = new FormData();
          formData.append('file', file);

          let upload_path =
            type === 'client'
              ? '/client/profile/upload/image'
              : '/admin/profile/upload/image';
          let upload_response = await newFetch(
            PUT,
            upload_path,
            formData,
            'form'
          );

          if (!upload_response.success) {
            ToastUtil.success(upload_response.message);
          }
        }

        let response = await newFetch(PUT, api_path, data);

        ToastUtil.success(response.message);

        response.success && window.location.reload();
      }
    }
  };

  const fetchUser = async () => {
    var api_path = '';

    api_path = `/admin/admins/${user.id}`;

    let response = await newFetch(GET, api_path);

    setFetchedUser(response.data);
    setFirstName(
       response.data.first_name
    );
    setLastName(
       response.data.last_name
    );
    setEmail(response.data.email);
    setPhoneNo(response.data.phone_no);
    setPhoto(
      response.data.image ? `${SERVER_URL}/${response.data.image}` : null
    );
  };

  useEffect(() => {
    if (user) {
      fetchUser();
    }
  }, []);

  return (
    <form
      onSubmit={(e) => submitAccountHandler(e)}
      className="d-flex flex-column"
    >
      <div className="p-4 d-flex flex-column">
        <h5 className="mb-4 pb-2">Account Information</h5>
        <div className="row">
          <div className="col-4 text-center d-flex flex-column">
            <div>
              <img
                className="img-responsive rounded-circle border"
                style={{ height: '100px', width: '100px' }}
                src={photo}
                alt="user-profile"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = placeholderImage;
                }}
              />
            </div>
            <div className="mt-2">
              <input
                id="uploadPhoto"
                type="file"
                hidden
                onChange={(e) => photoHandler(e)}
              />
              <Link
                to="#"
                onClick={() => document.getElementById('uploadPhoto').click()}
              >
                {' '}
                Change{' '}
              </Link>
            </div>
          </div>
          <div className="col-8">
            <div className="mb-2">
              <label htmlFor="firstName" className="fw-semibold mb-2">
                First Name
              </label>
              <input
                type="text"
                className="form-control adjust-fs"
                id="firstName"
                placeholder="Enter First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="mb-2">
              <label htmlFor="lastName" className="fw-semibold mb-2">
                Last Name
              </label>
              <input
                type="text"
                className="form-control adjust-fs"
                id="lastName"
                placeholder="Enter Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="mb-2">
              <label htmlFor="email" className="fw-semibold mb-2">
                Email
              </label>
              <input
                type="email"
                className="form-control adjust-fs"
                id="email"
                placeholder="Enter Email"
                value={email}
                disabled={true}
              />
            </div>
            <div className="mb-2">
              <label htmlFor="phoneNo" className="fw-semibold mb-2">
                Phone No
              </label>
              <input
                type="text"
                className="form-control adjust-fs"
                id="phoneNo"
                placeholder="Enter Phone No"
                value={phoneNo || ''}
                onChange={(e) => setPhoneNo(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          height: '4.5rem',
        }}
        className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
      >
        <button
          type="button"
          onClick={discardAccountHandler}
          className="btn btn-outline-brand adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn btn-brand ms-3 adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Save changes
        </button>
      </div>
    </form>
  );
};

export default withRouter(Account);
